import React, { useState, useEffect } from 'react';
import { supabase } from '../api/supabase';
import { Grid, Typography, Box, Paper } from '@mui/material';
import Loader from '../components/common/Loader';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import InventoryIcon from '@mui/icons-material/Inventory';
import StorefrontIcon from '@mui/icons-material/Storefront';
// 'PriceCheckIcon' foi REMOVIDO da lista de imports.

// Componente de Card
const StatCard = ({ title, value, isCurrency = false, color }) => (
  <Paper 
    elevation={3} 
    sx={{ 
      p: 2, 
      textAlign: 'center',
      borderTop: `4px solid ${color}`,
    }}
  >
    <Typography variant="subtitle1" color="text.secondary">{title}</Typography>
    <Typography 
      variant="h4" 
      sx={{ 
        fontWeight: 'bold', 
        color: 'text.primary'
      }}
    >
      {isCurrency ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : value}
    </Typography>
  </Paper>
);

const DashboardPage = () => {
  const [dailyStats, setDailyStats] = useState({ clients: 0, salesValue: 0, profit: 0, itemsSold: 0 });
  const [stockStats, setStockStats] = useState({ totalItems: 0, totalValue: 0 });
  const [totalSalesEver, setTotalSalesEver] = useState(0); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
      const todayEnd = new Date(); todayEnd.setHours(23, 59, 59, 999);

      const [salesTodayData, itemsTodayData, productsData, allSalesData] = await Promise.all([
        supabase.from('sales').select('client_id, total_amount, total_cost').gte('created_at', todayStart.toISOString()).lte('created_at', todayEnd.toISOString()),
        supabase.from('sale_items').select('quantity, sales!inner(created_at)').gte('sales.created_at', todayStart.toISOString()).lte('sales.created_at', todayEnd.toISOString()),
        supabase.from('products').select('quantity, cost_price'),
        supabase.from('sales').select('total_amount') 
      ]);

      if (salesTodayData.data) {
        const sales = salesTodayData.data;
        const items = itemsTodayData.data;
        const uniqueClients = new Set(sales.map(s => s.client_id).filter(Boolean)).size;
        const totalSalesValue = sales.reduce((acc, s) => acc + Number(s.total_amount), 0);
        const totalCostValue = sales.reduce((acc, s) => acc + Number(s.total_cost), 0);
        const totalItemsSold = items ? items.reduce((acc, i) => acc + i.quantity, 0) : 0;
        setDailyStats({ clients: uniqueClients, salesValue: totalSalesValue, profit: totalSalesValue - totalCostValue, itemsSold: totalItemsSold });
      }

      if (productsData.data) {
        const products = productsData.data;
        const totalItems = products.reduce((acc, p) => acc + p.quantity, 0);
        const totalValue = products.reduce((acc, p) => acc + (p.quantity * p.cost_price), 0);
        setStockStats({ totalItems, totalValue });
      }
      
      if (allSalesData.data) {
        const total = allSalesData.data.reduce((acc, sale) => acc + Number(sale.total_amount), 0);
        setTotalSalesEver(total);
      }

      setLoading(false);
    };
    fetchDashboardData();
  }, []);

  if (loading) return <Loader />;

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Dashboard de Hoje</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} md={4}><StatCard title="Vendas do Dia" value={dailyStats.salesValue} icon={<AttachMoneyIcon />} isCurrency color="#f06292" /></Grid>
        <Grid item xs={6} md={4}><StatCard title="Lucro do Dia" value={dailyStats.profit} icon={<MonetizationOnIcon />} isCurrency color="#4CAF50" /></Grid>
        <Grid item xs={6} md={4}><StatCard title="Itens Vendidos" value={dailyStats.itemsSold} icon={<ShoppingBasketIcon />} color="#FFB74D" /></Grid>
        <Grid item xs={6} md={4}><StatCard title="Clientes do Dia" value={dailyStats.clients} icon={<PeopleAltIcon />} color="#9575CD" /></Grid>
        <Grid item xs={6} md={4}><StatCard title="Itens em Estoque" value={stockStats.totalItems} icon={<InventoryIcon />} color="#78909C" /></Grid>
        <Grid item xs={6} md={4}><StatCard title="Valor do Estoque" value={stockStats.totalValue} isCurrency color="#6D4C41" /></Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>Visão Geral</Typography>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                 <StatCard 
                    title="Vendas Totais (Geral)" 
                    value={totalSalesEver} 
                    icon={<StorefrontIcon />} 
                    isCurrency 
                    color="#AD1457"
                />
            </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default DashboardPage;